import { Avatar } from '@mui/material';
import styled from 'styled-components';

type Props = {
  thumbnailUrl?: string;
  size?: number;
  name?: string;
};

export const TargetAudienceAvatar = ({ thumbnailUrl, size = 24, name }: Props) => {
  if (thumbnailUrl) {
    return <StyledImg src={thumbnailUrl} $size={size} />;
  }

  return <StyledAvatar $size={size}>{name?.charAt(0).toUpperCase()}</StyledAvatar>;
};

const StyledImg = styled.img<{ $size: number }>`
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  outline: ${({ theme }) => `1px solid ${theme.colors.commonBlackFocusvisible}`};
  border-radius: 50%;
  object-fit: cover;
`;

const StyledAvatar = styled(Avatar)<{ $size: number }>`
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};

  font-size: ${({ $size }) => `${$size / 2}px`};
`;
